import { render, staticRenderFns } from "./ChatAudioPlayer.vue?vue&type=template&id=37a2ecfa&scoped=true&"
import script from "./ChatAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./ChatAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ChatAudioPlayer.vue?vue&type=style&index=0&id=37a2ecfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a2ecfa",
  null
  
)

export default component.exports